import { render, staticRenderFns } from "./EventDetailHeader.vue?vue&type=template&id=5642a9f8&scoped=true&"
import script from "./EventDetailHeader.vue?vue&type=script&lang=js&"
export * from "./EventDetailHeader.vue?vue&type=script&lang=js&"
import style0 from "./EventDetailHeader.vue?vue&type=style&index=0&id=5642a9f8&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5642a9f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5642a9f8')) {
      api.createRecord('5642a9f8', component.options)
    } else {
      api.reload('5642a9f8', component.options)
    }
    module.hot.accept("./EventDetailHeader.vue?vue&type=template&id=5642a9f8&scoped=true&", function () {
      api.rerender('5642a9f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EventDetailHeader.vue"
export default component.exports